import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import { installUnhandledRejectionReporting } from './lib/telemetry'
import { initWebVitalsReporting } from './lib/webVitals'
import { reloadOnceForStaleChunk } from './lib/chunkReload'
import './lib/posthogClient'
import './index.css'

// Vite fires this when a lazily loaded file cannot be fetched, which after a
// release means this tab is running the previous version. Reload to get the new one.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForStaleChunk()) event.preventDefault()
})

installUnhandledRejectionReporting()
initWebVitalsReporting()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
